import React, { useCallback, useMemo } from 'react';
import { ResultResourceData } from 'framework/crud';
import { components, OptionProps } from 'react-select';
import { Tooltip } from 'framework/ui/mui-builder';
import { LoadDropdown, DefaultDropdownProps } from 'framework/form';
import useWasteService from './useWasteService';

interface RedmineTicket {
  id: string;
  projectIdentifier?: string;
  subject: string;
  violatesBusinessRules: boolean;
}

interface TypeRedmineTicketsMultiSelect extends DefaultDropdownProps {
  loadMethod: () => ResultResourceData;
  deps?: any[];
  isClearValueByUpdateDeps?: boolean;
}

const CustomOption = (props: OptionProps<any>) => {
  const { data, innerRef, innerProps } = props;
  return (
    <Tooltip
      placement="right"
      title={data.violatesBusinessRules ? `The issue has time reports earlier than 2 weeks ago!` : ``}
    >
      <div ref={innerRef} {...innerProps}>
        <components.Option {...props}>{props?.children}</components.Option>
      </div>
    </Tooltip>
  );
};

const RedmineTicketsMultiSelect: React.FC<TypeRedmineTicketsMultiSelect> = ({
  loadMethod,
  deps,
  isClearValueByUpdateDeps = true,
  ...props
}) => {
  const { isHasWithViolations } = useWasteService();

  const mapResults = useCallback(
    (result: RedmineTicket): any => ({
      value: `${result.id}`,
      label: `${result.id}`,
      disabled: !isHasWithViolations && result.violatesBusinessRules,
      violatesBusinessRules: result.violatesBusinessRules,
    }),
    [isHasWithViolations],
  );

  const customComponents = useMemo(() => ({ Option: CustomOption }), []);

  return (
    <LoadDropdown
      {...props}
      mapResults={mapResults}
      multiple
      loadDataMethod={loadMethod}
      deps={deps}
      placeholder="Choose ticket ID (s)"
      components={customComponents}
      isClearValueByUpdateDeps={isClearValueByUpdateDeps}
    />
  );
};

export default RedmineTicketsMultiSelect;
